<template>
    <div :class="['numbers', disabledInput ? 'disabledInput' : '', hidden ? 'd-none' : '']">
        <template v-if="customButtons">
            <div class="numpadrow" v-for="(cnumbers, idx) in customButtons" :key="idx">
                <template v-for="number in cnumbers">
                    <div @click.prevent="clr()" class="number error" :key="number" v-if="number == 'clr'">{{__('games.clear')}}</div>
                    <div @click.prevent="send()" class="number success" :key="number" v-else-if="number == 'check'">{{__('games.send')}}</div>
                    <div @click.prevent="addSingle(number)" class="number" :key="number" v-else>{{number}}</div>
                </template>
            </div>
        </template>
        <template v-else-if="only && only.indexOf('hit-nohit') > -1">
            <div class="numpadrow">
                <div @click.prevent="hit()" class="number success">HIT</div>
                <div @click.prevent="nohit()" class="number error">NO HIT</div>
            </div>
            <div class="numpadrow">
                <div @click.prevent="clr()" class="number error">{{__('games.clear')}}</div>
                <div @click.prevent="send()" class="number success">{{__('games.send')}}</div>
            </div>
        </template>
        <template v-else>
            <div class="numpadrow">
                <div @click.prevent="checkout()" :class="['number success', allowCheck ? '' : 'disabled']" v-if="notHidden('check')">{{__('games.check')}}</div>
                <div class="clear"></div>
                <div @click.prevent="rest()" class="number darker" v-if="notHidden('rest')">{{__('games.rest')}}</div>
                <div @click.prevent="sendQuick(quicks[0])" class="number quick" v-if="notHidden('quick')">{{quicks[0]}}</div>
            </div>
            <div class="numpadrow">
                <div @click.prevent="add(1)" class="number">1</div>
                <div @click.prevent="add(2)" class="number">2</div>
                <div @click.prevent="add(3)" class="number">3</div>
                <div @click.prevent="sendQuick(quicks[1])" class="number quick" v-if="notHidden('quick')">{{quicks[1]}}</div>
            </div>
            <div class="numpadrow">
                <div @click.prevent="add(4)" class="number">4</div>
                <div @click.prevent="add(5)" class="number">5</div>
                <div @click.prevent="add(6)" class="number">6</div>
                <div @click.prevent="sendQuick(quicks[2])" class="number quick" v-if="notHidden('quick')">{{quicks[2]}}</div>
            </div>
            <div class="numpadrow">
                <div @click.prevent="add(7)" class="number">7</div>
                <div @click.prevent="add(8)" class="number">8</div>
                <div @click.prevent="add(9)" class="number">9</div>
                <div @click.prevent="sendQuick(quicks[3])" class="number quick" v-if="notHidden('quick')">{{quicks[3]}}</div>
            </div>
            <div class="numpadrow">
                <div @click.prevent="clr()" class="number error">{{__('games.clear')}}</div>
                <div @click.prevent="add(0)" class="number">0</div>
                <div @click.prevent="send()" class="number success">{{__('games.send')}}</div>
                <div @click.prevent="sendQuick(quicks[4])" class="number quick" v-if="notHidden('quick')">{{quicks[4]}}</div>
            </div>
        </template>
        <b-modal id="modal-checkout" title="Check Out" size="lg" hide-footer>
            <h1 class="text-center" v-html="__('games.how_many_darts')"></h1>
            <div class="row">
                <div class="col-3" @click.prevent="check(1)">
                    <div class="btn-checkout btn btn-block btn-success">1<div class="smalltext">{{__('games.darts')}}</div></div>
                </div>
                <div class="col-3" @click.prevent="check(2)">
                    <div class="btn-checkout btn btn-block btn-success">2<div class="smalltext">{{__('games.darts')}}</div></div>
                </div>
                <div class="col-3" @click.prevent="check(3)">
                    <div class="btn-checkout btn btn-block btn-success">3<div class="smalltext">{{__('games.darts')}}</div></div>
                </div>
                <div class="col-3" @click.prevent="check(0)">
                    <div class="btn-checkout btn btn-block btn-danger">X<div class="smalltext" v-html="__('games.overthrown')"></div></div>
                </div>
            </div>
        </b-modal>

        <b-modal id="modal-numpad-helper" :title="__('games.input_help')" size="md" hide-footer>
            <h3 v-html="__('games.keyboard_input')"></h3>
            <p v-html="__('games.keyboard_input_text')"></p>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>{{__('games.value')}}</th>
                        <th>{{__('games.shortcut')}}</th>
                    </tr>
                </thead>
                <tbody>
                <tr>
                    <th>{{__('games.numbers_1_to_0')}}</th>
                    <td>{{__('games.upper_row')}} <span class='key__button'>1</span> {{__('games.to')}} <span class='key__button'>0</span><br><br>{{__('games.numblock')}} <span class='key__button'>1</span> {{__('games.to')}} <span class='key__button'>0</span></td>
                </tr>
                <tr>
                    <th>{{__('games.send')}}</th>
                    <td><span class='key__button'>ENTER</span> {{__('games.or')}} <span class='key__button'>RETURN</span></td>
                </tr>
                <tr>
                    <th>{{__('games.delete_value')}}</th>
                    <td><span class='key__button'>{{__('games.backspace')}}</span></td>
                </tr>
                <tr>
                    <th>{{__('games.checkout_window')}}</th>
                    <td><span class='key__button'>{{__('games.spacebar')}}</span></td>
                </tr>
                <tr>
                    <th>{{__('games.quick_input')}} 26, 45, 60, 85, 100 ({{__('games.only')}} x01)</th>
                    <td><span class='key__button'>SHIFT</span> +
                    <span class='key__button'>1</span>,
                    <span class='key__button'>2</span>,
                    <span class='key__button'>3</span>,
                    <span class='key__button'>4</span>,
                    <span class='key__button'>5</span>
                     {{__('games.in_upper_row')}}</td>
                </tr>
                <tr>
                    <th>{{__('games.rest')}} ({{__('games.only')}} x01)</th>
                    <td>{{__('games.after_throw')}} <span class='key__button'>SHIFT</span> + <span class='key__button'>ENTER</span>/<span class='key__button'>RETURN</span></td>
                </tr>
                </tbody>
            </table>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: ['disabledInput', 'allowCheck', 'checkbutton', 'hide', 'hidden', 'only'],
        data() {
            return {
                checkWindowOpen: false,
                quicks: [26, 45, 60, 85, 100],
                customButtons: null,
                keyboard_shortcuts: [],
                hideCheck: this.hide,
            }
        },
        created() {
            if (this.only) {
                this.hideCheck = ['rest', 'quick', 'check'];
            }
        },
        mounted() {
            window.addEventListener('keyup', (ev) => {
                this.keyboardInput(ev);
            });

            this.addPlayerOptions();
            this.clr();
        },
        methods: {
            keyboardInput(ev) {
                //do not allow inputs if input is disabled
                if (this.disabledInput) return;
                if (this.checkWindowOpen) {
                    if (ev.code == "Backspace" || ev.code == "Escape") {
                        this.hideCheckoutWindow();
                    }
                    for (let i = 1; i <= 3; i++) {
                        if (ev.code == "Numpad"+i || ev.code=="Digit"+i)
                            this.check(i);
                    }
                    //overthrown with number 4
                    if (ev.code == "Numpad4" || ev.code=="Digit4")
                        this.check(0);
                } else {
                    //create string from pressed buttons
                    let pressedKeys = '';
                    if (ev.shiftKey) pressedKeys += "SHIFT + ";
                    if (ev.altKey) pressedKeys += "ALT + ";
                    if (ev.controlKey) pressedKeys += "CTRL + ";
                    pressedKeys += ev.code;
                    //check against shortcuts
                    let foundShortcut = undefined;
                    this.keyboard_shortcuts.forEach(shortcut => {
                        if (shortcut.value == pressedKeys) {
                            foundShortcut = shortcut.name;
                        }
                    });

                    if (foundShortcut) {
                        if (foundShortcut == "keyboard_nextplayer") {
                            this.send();
                            return;
                        }
                        if (foundShortcut == "keyboard_clear") {
                            this.clr();
                            return;
                        }
                        if (foundShortcut == "keyboard_rest") {
                            this.rest();
                        }
                        if (foundShortcut == "keyboard_check") {
                            this.checkout()
                        }
                        if (foundShortcut.indexOf('quick') != -1) {
                            let quick = parseInt(foundShortcut.replace("keyboard_quick", '')) - 1;
                            this.sendQuick(this.quicks[quick]);
                        }
                    }

                    if (this.only && this.only.indexOf('hit-nohit') != -1) {
                        if (ev.code == "Numpad1" || ev.code=="Digit1") this.hit();
                        if (ev.code == "Numpad2" || ev.code=="Digit2") this.nohit();
                    } else {
                        for (let i = 0; i < 10; i++) {
                            if (ev.code == "Numpad"+i || ev.code=="Digit"+i)
                                this.add(i);
                        }
                    }

                }
            },
            sendQuick(number) {
                if (this.disabledInput) return;
                this.$emit('clr');
                this.$emit('add', number);
                this.$emit('send');
            },
            add(number) {
                if (this.disabledInput) return;
                this.$emit('add', number);
            },
            addSingle(number) {
                if (this.disabledInput) return;
                this.$emit('addSingle', number);
            },
            clr() {
                this.$emit('clr');
            },
            send() {
                if (this.disabledInput) return;
                this.$emit('send');
            },
            check(dart) {
                if (this.disabledInput) return;
                this.$emit('check', dart);
                this.hideCheckoutWindow();
            },
            rest() {
                if (this.disabledInput) return;
                this.$emit('rest');
            },
            checkout() {
                if (this.allowCheck) {
                    this.$bvModal.show('modal-checkout');
                    this.checkWindowOpen = true;
                }
            },
            hit() {
                if (this.disabledInput) return;
                this.$emit('hit');
            },
            nohit() {
                if (this.disabledInput) return;
                this.$emit('nohit');
            },
            hideCheckoutWindow() {
                this.$bvModal.hide('modal-checkout');
                this.checkWindowOpen = false;
            },
            notHidden(option) {
                if (!this.hideCheck) return true;
                var returnValue = true;
                this.hideCheck.forEach(element => {
                    if (element == option) {
                        returnValue = false;
                    }
                });
                return returnValue;
            },
            toggleHelper() {
                this.$bvModal.show('modal-numpad-helper');
            },
            setButtons(buttons) {
                this.customButtons = buttons;
            },
            addPlayerOptions() {
                setTimeout(() => {
                    if (window.player == null) return;
                    this.quicks = [];
                    for (const key in window.player) {
                        if (Object.hasOwnProperty.call(window.player, key)) {
                            const element = window.player[key];
                            if (key.indexOf('keyboard') != -1)
                                this.keyboard_shortcuts.push({name: key, value: element});
                            if (key.indexOf('value_quick') != -1) {
                                this.quicks.push(element);
                            }
                        }
                    }
                }, 1000);
            }
        }
    }
</script>

<style scoped>
    .btn-number {
        width: 100%;
        height: 10vh;
        text-align: center;
        line-height: 10vh;
        font-size: 5em;
        background-color: #ddd;
        color: #333;
        font-weight: bold;
        margin-top: 2vh;
    }

    .btn-clr {
         background-color: red;
         color: #fff;
    }

    .btn-send {
         background-color: green;
         color: #fff;
    }

    .btn-check {
         background-color: rgb(107, 107, 107);
         color: #fff;
    }

    .btn-check.btn-check-allowed {
        background-color: green;
        color: #fff;
    }

    .btn-check.btn-check-disabled {
        background-color: rgb(107, 107, 107);
         color: #fff;
    }

    .btn-checkout {
        height: 120px;
        text-align: center;
        line-height: 1em;
        font-size: 6em;
        font-weight: bold;
        margin-top: 2vh;
    }

    .btn-checkout .smalltext {
        font-size: 0.25em;
        margin-top: -2em;
    }


.key__button {
    box-sizing: border-box;
    font-size: 1rem;
    text-align: center;
    min-width: 2em;
    padding: 0 1em;
    color: #555;
    cursor: pointer;
    margin: 0 8px;
    border-color: #f2f2f2;
    border-style: solid;
    text-shadow: 0 0.5px 1px #777, 0 2px 6px #f2f2f2;
    border-width: 1px;
    border-radius: 10px;
    background: -webkit-linear-gradient(top, #f9f9f9 0%, #D2D2D2 80%, #c0c0c0 100%);
    font-family: sans-serif;
    display: inline-block;
    transition: box-shadow 0.3s ease, transform 0.15s ease;
    box-shadow: 0 0 1px #888, 0 1px 0 #fff, 0 3px 10px #aaa;
}
</style>
